import React from "react";
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import np1 from "../assets/images/np1.svg";
import np2 from "../assets/images/np2.svg";
import np3 from "../assets/images/np3.svg";
import n1 from "../assets/images/n1.svg";
import n2 from "../assets/images/n2.svg";
import { useNavigate } from "react-router-dom";

const newsData = [
  {
    title: "Almost all USAID workers across the globe placed on leave as presiden...",
    source: "USA Today",
    time: "2h ago",
    loves: "244",
    comments: "12",
    logo: np1, // Local image
  },
  {
    title: "Utah Hockey Club logo leak? Three possibilities solution...",
    source: "USA Today",
    time: "1d ago",
    loves: "36",
    comments: "1",
    logo: np2,
    image: n1,
  },
  {
    title: "Novo Nordisk sees slower sales growth in 2025",
    source: "Reuters",
    time: "1w ago",
    loves: "12",
    comments: "4",
    logo: np3,
    image: n2,
  },
];

const LatestNews = ({ title = "Latest News" }) => {
  const navigate = useNavigate();
  return (
    <div className="latest-news">
      <h3 className="mb-15">{title}</h3>
        <div className="latest-news-card">
            <div className="latest-news-card-top">
                {newsData.map((news, index) => (
                    <Link key={index} to={`/news/${index}`} className="latest-news-card-item">
                            <div className="latest-news-card-item-inner">
                                <h5>{news.title}</h5>
                                <div className="latest-news-card-element">
                                    <img src={news.logo} alt={news.source} className="news-logo" />
                                    <span className="p-name">{news.source}</span>
                                    <span className="devider">•</span>
                                    <span>{news.time}</span>
                                </div>
                                <div className="latest-news-card-coments">
                                    <span>{news.loves} Loves</span> 
                                    <span className="devider">•</span>
                                    <span>{news.comments} Comments</span>
                                </div>
                            </div>
                            {news.image && (
                                <img src={news.image} alt="news" className="w-12 h-12 rounded-md object-cover ml-3" />
                            )}
                    </Link>
                ))}
            </div>
            <div className="latest-news-card-button">
                <Button variant="link" onClick={() => navigate("/news")}>View All</Button>
            </div>
        </div>
    </div>
  );
};

export default LatestNews;
